var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-loading-indicator loading-indicator",class:[ _vm.vm.colorClass, _vm.size ]},[_c('span',{class:_vm.loadingType})])
}
var staticRenderFns = []

export { render, staticRenderFns }